import React from 'react';
import { Icon, IconProps } from './Icon';

export const UserIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M9.00013 12.9167C5.91811 12.9167 3.17729 14.4048 1.43234 16.7141C1.05678 17.2112 0.869004 17.4597 0.875146 17.7956C0.879891 18.055 1.04284 18.3824 1.24701 18.5426C1.51128 18.75 1.8775 18.75 2.60994 18.75H15.3903C16.1228 18.75 16.489 18.75 16.7532 18.5426C16.9574 18.3824 17.1204 18.055 17.1251 17.7956C17.1313 17.4597 16.9435 17.2112 16.5679 16.7141C14.823 14.4048 12.0821 12.9167 9.00013 12.9167Z"
        stroke="#808080"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00013 10C11.4164 10 13.3751 8.04125 13.3751 5.625C13.3751 3.20875 11.4164 1.25 9.00013 1.25C6.58388 1.25 4.62513 3.20875 4.62513 5.625C4.62513 8.04125 6.58388 10 9.00013 10Z"
        stroke="#808080"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};
